<div class="snackbar-content" data-cy="snackbar">
  <div class="message">
    @if (isSuccessSnackbar) {
      <mat-icon
        class="success-icon"
        fontIcon="icon-check-1c-r-b-24-fontastic"
        inline="true"
      ></mat-icon>
    } @else {
      <mat-icon
        class="failed-icon"
        fontIcon="icon-alerte-input"
        inline="true"
      ></mat-icon>
    }
    <span data-cy="snackbar-message">{{ data.message }}</span>
  </div>
  @if (data.actionButtonText) {
    <button
      class="actions"
      xxsmall
      tiime-button
      neutral
      inverted
      light
      (click)="close()"
      >
      {{ data.actionButtonText }}
    </button>
  }
  @if (!data.actionButtonText) {
    <div class="actions" (click)="close()">OK</div>
  }
</div>
